import "./ProfileSetupScreen.css";
import { useEffect, useState } from "react";
import letsDoItIcon from "../../assets/images/lets-do-it-icon.svg";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useStorage } from "services/StorageProvider";

const ProfileSetupScreen = () => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const { userProfileData } = useStorage();
  const isValidPhoneNumber = (number: string) => {
    const normalized = number.replace(/^\+/, "");
    const phoneNumber = parsePhoneNumberFromString("+" + normalized);
    return phoneNumber ? phoneNumber.isValid() : false;
  };
  const isDisabled =
    !firstName.trim() ||
    !mobileNumber.trim() ||
    !isValidPhoneNumber(mobileNumber);

  useEffect(() => {
    setFirstName(userProfileData?.first_name || "");
    setLastName(userProfileData?.last_name || "");
    setMobileNumber(userProfileData?.mobile_number?.replace("+", "") || "");
  }, [userProfileData]);

  useEffect(() => {
    const storedLeadData = sessionStorage.getItem("customerLeadData");
    if (storedLeadData) {
      const leadData = JSON.parse(storedLeadData);
      setFirstName(leadData.name || "");
      setMobileNumber((leadData.phone || "").replace(/^\+/, ""));
    }
  }, []);

  const handleContinueClick = () => {
    navigate(ROUTE_PATHS.WSM_PROFILE_SETUP_DETAIL, {
      state: { firstName, lastName, mobileNumber },
      replace: true,
    });
  };

  return (
    <div className="wms-mobile-container">
      <div className="profile-setup-screen-container">
        <header className="profile-setup-screen-header-header-bar">
          Enter the Realm
        </header>
        <div className="profile-setup-screen-top-container">
          <div className="text-container">
            <span>
              A 3<sup className="sub-text">rd </sup> Space
            </span>
            <span style={{ color: "#ff6b35" }}> Ecosystem</span>
          </div>
        </div>
        <div className="profile-setup-screen-banner-container">
          <div className="second-text">
            Where{" "}
            <span style={{ color: "#FF6B35" }}>
              High Performance and Human Wellbeing coexist by Design.
            </span>{" "}
            For Founders, Business Owners, Professionals, Creators.
          </div>
          <div className="divider"></div>
        </div>
        <div className="profile-setup-screen-item-container">
          <span>
            First <span className="sub-text">Name</span>
            <span className="required">*</span>
          </span>
          <input
            placeholder="Enter First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="profile-setup-screen-item-container">
          <span>
            Last <span className="sub-text">Name</span>
          </span>
          <input
            placeholder="Enter Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
        <div className="profile-setup-screen-item-container">
          <span>
            Phone <span className="sub-text">Number</span>
            <span className="required">*</span>
          </span>
          <PhoneInput
            country={"in"}
            value={mobileNumber}
            onChange={setMobileNumber}
            countryCodeEditable={false}
            inputProps={{
              name: "mobile",
              required: true,
              autoFocus: true,
            }}
            containerClass="profile-setup-custom-phone"
            inputClass="profile-setup-custom-phone-input"
          />
        </div>
        <button onClick={handleContinueClick} disabled={isDisabled}>
          <>
            Continue
            <img src={letsDoItIcon} alt="lets-do-it-logo" />
          </>
        </button>
      </div>
    </div>
  );
};

export default ProfileSetupScreen;
